import SparksOverlay from "../sparks-overlay/sparks-overlay";
import { LoginCardProps } from "./login-card-type";
import { LoginContent, HeadingContainerStyled, TitleStyled, ContentTitleStyled } from "./login-card-style";
import CustomButton from "../custom-button/custom-button";
import IconGiftBadge from "@/assets/icons/GiftBadge.svg";

const LoginCard: React.FC<LoginCardProps> = ({ onClick, show = false }) => {
  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick?.();
    }
  }

  if (!show) return null;

  return (
    <LoginContent>

      <HeadingContainerStyled>
        <img src={IconGiftBadge} alt="icon" />
        <ContentTitleStyled>
          <TitleStyled>¡Participar ahora!</TitleStyled>
          <p>Inicia sesión para iniciar la misión y ganar esta recompensa.</p>
        </ContentTitleStyled>
      </HeadingContainerStyled>
      <CustomButton
        onClick={handleClick}
        type="default"
        style={{ width: '100%', zIndex: 110 }}
      >
        Iniciar sesión
      </CustomButton>
      <SparksOverlay activeBandWhite={false} />
    </LoginContent>
  )
}

export default LoginCard;
